// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import styled from "styled-components";
import ReactGA from "react-ga4";
import Home from "./components/Home";
import Footer from "./components/Footer";
import Header from "./components/Header";
import DoomDashboard from "./components/DoomDashboard";
import "./App.css";

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

// The old in-site prototype at /elci now lives at elci.life
function ElciRedirect() {
  useEffect(() => {
    window.location.replace("https://elci.life");
  }, []);

  return null;
}

// Create a component to handle route changes
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

function AppLayout() {
  const isDoomHost = window.location.hostname.toLowerCase().startsWith("doom.");

  if (isDoomHost) {
    return (
      <AppContainer>
        <RouteTracker />
        <ContentWrapper>
          <DoomDashboard />
        </ContentWrapper>
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      <RouteTracker />
      <Header />
      <ContentWrapper>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/elci" element={<ElciRedirect />} />
          <Route path="/doom" element={<DoomDashboard />} />
        </Routes>
      </ContentWrapper>
      <Footer />
    </AppContainer>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
